import '../App.css';

function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-box">
        <h1 className="contact-title">Contact Us</h1>
        <div className="contact-info">
          <div className="contact-row">
            <span className="contact-icon">📍</span>
            <div>
              <div className="contact-label">Address</div>
              <div className="contact-value">1555 W Shoreline Dr Ste 100, Boise, Idaho 83702</div>
            </div>
          </div>
          <div className="contact-row">
            <span className="contact-icon">✉️</span>
            <div>
              <div className="contact-label">Email</div>
              <div className="contact-value">info@idxexchange.com</div>
            </div>
          </div>
          <div className="contact-row">
            <span className="contact-icon">☎️</span>
            <div>
              <div className="contact-label">Phone</div>
              <div className="contact-value">(650) 209-0551</div>
            </div>
          </div>
        </div>
        <form className="contact-form" onSubmit={e => { e.preventDefault(); alert('Message sent!'); }}>
          <h2 className="contact-form-title">Send us a message</h2>
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" placeholder="Your Message" rows={4} required />
          <button className="contact-btn" type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;